module.exports = new __parcel__URL__("PDFexport.298a755d.png").toString();